import React, { Component } from 'react';
import photoWho from '../assets/photoWho.jpg';

import '../App.css';

class Who extends Component {
  render() {
    return (
      <div className="App">
        <div className="boxWho">

        <div className="desc"><br />

          <h1>Chi siamo</h1>
          <h2>Al GrowShop di Senago troverete l’intero catalogo presente a <a href="https://www.botanicaurbana.com/?SID=aea8fca8c4a48c535839afad818e583b">sito</a> sempre disponibile. <br />
          L’impeccabile consulenza di Albi e Nico, esperti nelle principali tecniche di coltivazione sia indoor che outdoor, idroponica , aeroponica, terra e cocco, sarà messa a vostra disposizione al fine di realizzare i vostri progetti. <br/>
          Completano il catalogo un’ampia scelta delle migliori varietà di cannabis light presenti sul mercato e una selezione d’elite di semi da collezione femminizzati e autofiorenti. <br /> <br />
          Passa a trovarci!</h2>
        </div>

        
            <div className="photoWho">
              <img src={photoWho} alt="Albi e Nico di Botanica Urbana Senago" />
            </div>

        </div>
      </div>
    )
  }
}


export default Who;
